export default __webpack_public_path__ + "static/media/girl2.f6494577.jpg";